export default "__VITE_ASSET__Cjercd1N__"